import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type RoundResultsListQueryParams = Parameters<typeof SSF.api.roundResultsList>[0];

export const keys = createQueryKeySet<RoundResultsListQueryParams>('round-results');

export function useRoundResultsListQuery(params?: RoundResultsListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.roundResultsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}

export function useRoundResultsQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.roundResultsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
